import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {UserProfile} from '../models/user-profile.model';
import {Observable, of} from 'rxjs';
import {ReferralListFilterModel} from '../models/referral-list-filter.model';
import {PageableApiResult} from '../models/pagable-api-result.model';
import {ReferralModel} from '../models/referral.model';
import {and} from 'rsql-builder';
import {Transaccion} from '../models/transaccion.model';
import {UserDiscountModel} from '../models/user-discount.model';


@Injectable({providedIn: 'root'})
export class UserProfileApiService {

  private readonly profileBaseUrl = environment.apiBaseUrl + `/v1/core/portal/profile`;

  constructor(
    private http: HttpClient
  ) {
  }

  getUserProfile(): Observable<UserProfile> {
    return this.http.get<UserProfile>(environment.apiBaseUrl + `/core/portal/profile`);
  }

  uploadProfileImage(fileType: string, imageBase64: string) {

    return this.http.post<any>(environment.apiBaseUrl + `/core/portal/profile/profile_image/upload`,
      {
        contentType: fileType,
        imageBase64: imageBase64
      });

  }

  getProfileImage() {
    return this.http.get(environment.apiBaseUrl + `/core/portal/profile/profile_image`, {responseType: 'text'});
  }

  referFriend(email, link): Observable<any> {
    return this.http.post(environment.apiBaseUrl + `/core/portal/profile/reference`, {email, link});
  }

  getReferralLink(): Observable<any> {
    return this.http.get(environment.apiBaseUrl + `/core/portal/profile/referal_link`);
  }

  getReferrals(filter: ReferralListFilterModel): Observable<PageableApiResult<ReferralModel>> {

    const comps = [];
    let params = null;

    if (comps.length > 0) {
      let q = and(...comps).toString();
      params = new HttpParams().set("rquery", q);
    }else {

      params  = new HttpParams().set("rquery","id>0")
    }

    return this.http.get<PageableApiResult<ReferralModel>>(environment.apiBaseUrl + `/core/portal/profile/referidos/${filter.page}/${filter.size}`, {params});
  }
  getPartnerAssociated(): Observable<any> {
    return this.http.get<any>(environment.apiBaseUrl + `/core/portal/profile/partner`);
  }
  getUserPortalActiveDiscount(): Observable<UserDiscountModel> {
    return this.http.get<UserDiscountModel>(environment.apiBaseUrl + `/core/portal/profile/discount`);
  }
}

